import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html'
})
export class DeleteComponent {
  @Input() ariaLabel: string = '';
}
